import { render } from "./ProjectsCreateModal.vue?vue&type=template&id=6a3769bf"
import script from "./ProjectsCreateModal.vue?vue&type=script&lang=js"
export * from "./ProjectsCreateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__